import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import * as showdown from 'showdown'

@Component({
  selector: 'app-changelog',
  templateUrl: './changelog.component.html',
  styleUrls: ['./changelog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ChangelogComponent implements OnInit {
  changelogHtml = ''
  isLoading = true
  hasError = false

  private readonly markdownConverter = new showdown.Converter({
    noHeaderId: true,
    strikethrough: true,
  })

  constructor(private readonly httpClient: HttpClient) {}

  ngOnInit(): void {
    this.httpClient.get('/assets/changelog.md', { responseType: 'text' }).subscribe({
      next: changelog => {
        this.changelogHtml = this.markdownConverter.makeHtml(changelog)
        this.isLoading = false
      },
      error: () => {
        this.hasError = true
        this.isLoading = false
      },
    })
  }
}
